import Card from './ui/Card';
import GoogleLoginButton from './GoogleLoginButton';

function LoginPrompt({ title = 'Login necessário', message, onSuccess }) {
    return (
        <div className="flex items-center justify-center w-full max-w-md mx-auto mt-8 z-10">
            <Card className="p-8 w-full text-center">
                <h2 className="text-2xl font-bold text-slate-100 mb-3">{title}</h2>
                <p className="text-slate-300 mb-6">
                    {message || 'Faça login com sua conta Google para criar salas, entrar em sessões e participar do Planning Poker.'}
                </p>
                <div className="flex justify-center">
                    <GoogleLoginButton onSuccess={onSuccess} />
                </div>
            </Card>
        </div>
    );
}

export default LoginPrompt;
